import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND, TextFormatType } from 'lexical';
import * as React from 'react';
import StyleButton from './StyleButton';

const INLINE_STYLES: ReadonlyArray<{ label: string; style: TextFormatType }> = [
  { label: 'Bold', style: 'bold' },
  { label: 'Italic', style: 'italic' },
  { label: 'Underline', style: 'underline' },
];

const InlineStyleControls: React.FC = () => {
  const [editor] = useLexicalComposerContext();
  const [activeStyles, setActiveStyles] = React.useState<ReadonlyArray<TextFormatType>>([]);

  React.useEffect(
    () =>
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => {
          const selection = $getSelection();
          setActiveStyles(
            $isRangeSelection(selection)
              ? INLINE_STYLES.filter((type) => selection.hasFormat(type.style)).map(
                  (type) => type.style,
                )
              : [],
          );
        });
      }),
    [editor],
  );

  return (
    <>
      {INLINE_STYLES.map((type) => (
        <StyleButton
          key={type.label}
          active={activeStyles.indexOf(type.style) !== -1}
          label={type.label}
          onToggle={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, type.style)}
          style={type.style}
        />
      ))}
    </>
  );
};

export default InlineStyleControls;
